import * as XLSX from "xlsx";

export const DownloadExcel = (nameFile: string, nameSheet: string, header: string[], body: any[][]) => {
  // Crear workbook
  const workbook = XLSX.utils.book_new();

  // Combinar header + body
  const worksheetData = [header, ...body];

  // Crear worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Agregar worksheet al workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, nameSheet);

  // Descargar archivo real Excel
  XLSX.writeFile(workbook, `${nameFile}.xlsx`);
};
